module.exports = __webpack_public_path__ + "static/media/tr.03a37f92.png";